import { Component, h, Prop, Watch, Element } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY, delayPageChange } from '../../../global/utility/tracking-helpers';
import { getFromDay, getToDay } from '../../../helper';
import { Weekday } from '../../../types/weekday';

export interface UiCmsContactChannelsFooterPhoneBody {
  fromDay: Weekday;
  fromTime: string;
  number: string;
  toDay: Weekday;
  toTime: string;
}

@Component({
  tag: 'ui-cms-contact-channels-footer-phone',
  styleUrl: 'ui-cms-contact-channels-footer-phone.scss',
})
export class UiCmsContactChannelsFooterPhone {
  @Element() el: HTMLUiCmsContactChannelsFooterPhoneElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsFooterPhoneBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Prop({ mutable: true }) i18n: { [key: string]: string } = {
    fromMonday: 'Montag',
    fromTuesday: 'Dienstag',
    fromWednesday: 'Mittwoch',
    fromThursday: 'Donnerstag',
    fromFriday: 'Freitag',
    fromSaturday: 'Samstag',
    fromSunday: 'Sonntag',
    toMonday: 'Montag',
    toTuesday: 'Dienstag',
    toWednesday: 'Mittwoch',
    toThursday: 'Donnerstag',
    toFriday: 'Freitag',
    toSaturday: 'Samstag',
    toSunday: 'Sonntag',
    content:
      '{{fromDay}} bis {{toDay}} erreichen Sie uns <strong> von {{fromTime}} bis {{toTime}} Uhr telefonisch </strong> unter',
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Watch('utilityI18n')
  i18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...this.i18n, ...JSON.parse(newValue) };
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
    this.i18nChangeHandler(this.utilityI18n);
  }

  private parseI18nContent() {
    return this.i18n.content.replace(/\{\{(\w+)\}\}/g, (match, bodyKey) => {
      let result = '';

      if (bodyKey.includes('Day')) {
        const i18nKey = this.extractI18nKey(bodyKey);
        result = this.i18n[i18nKey];
      }

      if (bodyKey.includes('Time')) {
        result = this.body[bodyKey];
      }

      return result;
    });
  }

  private extractI18nKey(bodyKey) {
    const day = this.body[bodyKey].slice();
    return bodyKey.includes('to') ? getToDay(day) : getFromDay(day);
  }

  private onLinkClick(event: Event, link: HTMLAnchorElement) {
    delayPageChange(DEFAULT_TRACKING_DELAY, event, link);
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Phone',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.number,
        externalTarget: this.body.number,
      },
      category: {
        area: 'Footer',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    const link = `tel:${this.body.number}`;
    return (
      <div class="contactbox__item">
        <sd-icon
          class="contactbox__icon"
          library={window.ui.cmsState.iconLibrary}
          name="union-investment/content/mobile-phone"
          color={this.inverted ? 'white' : 'primary'}
        ></sd-icon>
        <p class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}>
          <span innerHTML={this.parseI18nContent()}></span>&nbsp;
          <sd-link
            inverted={this.inverted}
            href={link}
            class="nowrap"
            onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
            size="inherit"
          >
            <meta itemProp="telephone" content={this.body.number} />
            <strong>{this.body.number}</strong>
          </sd-link>
        </p>
      </div>
    );
  }
}
